module.exports = __webpack_public_path__ + "img/lens-150-minus-01.462bce60.png";